import axiosInstance from "../axiosInstance";
import {
    UserCreatePayload,
    UserApiResponse,
} from "../../types/superAdmin/userTypes";

/**
 * Create a new user
 */
export const createUser = async (
    payload: UserCreatePayload
): Promise<UserApiResponse> => {
    const response = await axiosInstance.post<UserApiResponse>(
        "/super-admin/users",
        payload
    );
    return response.data;
};

/**
 * Delete a user by ID
 */
export const deleteUser = async (userId: string): Promise<UserApiResponse> => {
    const response = await axiosInstance.delete<UserApiResponse>(
        `/super-admin/users/${userId}`
    );
    return response.data;
};
